import { q } from './utilities';
require('./init-jquery');

if (q('#landing-page')) {
  require('./landing-page');
}

if (q('#luxury-experience-rate.properties-page')) {
  require('./luxury-experience-rate');
}
